import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import Layout from '../../../components/Layout/Layout';
import Card from '../../../components/Card/Card';
import OfferCard from '../../../components/Offer/OfferCard';
import OfferLandings from '../../../components/Offer/OfferLandings';
import OfferStats from '../../../components/Offer/OfferStats';
import OfferNews from '../../../components/Offer/OfferNews';
import OfferTargetAudience from '../../../components/Offer/OfferTargetAudience';
import LandingRequest from '../../../components/LandingRequest/LandingRequest';
import DialogModal from '../../../modals/DialogModal/DialogModal';
import OfferHasFlowsModal from '../../../components/Offer/OfferHasFlowsModal';

import OfferAdditionalInfo from '../OfferAdditionalInfo';
import OfferCardInfo from '../../../components/Offer/OfferCardInfo';
import OfferCardControls from '../../../components/Offer/OfferCardControls';
import OfferCardItem from '../../../components/Offer/OfferCardItem';

const View = ({
  data: {
    offer,
    sources,
    offerSettings,
    countries,
    site_key,
    profile,
    loading,
    offerHasFlowsModalOpen,
    offerControlsModalOpen,
    confirmModal,
    isСopied,
  },
  baseCurrency,
  topBundle,
  onRequestOfferAccess,
  onRefuseOfferAccess,
  handleFlowCreate,
  renderAlertModal,
  handleModal,
  toggleModal,
  offerHasFlowsModalToggle,
  offerControlsModalToggle,
  copyFlow,
}) => (
  <div className="offer-page">
    <Breadcrumb>
      <BreadcrumbItem>
        <Link to="/offers/all">
          <FormattedMessage id="offers.breadcrumb" defaultMessage="All offers" />
        </Link>
      </BreadcrumbItem>
      <BreadcrumbItem active>{offer.title}</BreadcrumbItem>
    </Breadcrumb>

    <OfferCardInfo
      title={offer.title}
      id={offer.id}
      url={offer.url}
      modifies={offer.modifies}
      pic={`${offerSettings['images_path']}${offer.images ? offer.images[100] : ''}`}
      admit={offer.admit}
      categories={offer.categories}
    >
      <OfferCardControls
        offerId={offer.id}
        isMy={offer.modifies.is_my}
        hasAccess={offer.admit.has_access}
        hasPromo={offer.hasPromo}
        onRequestOfferAccess={onRequestOfferAccess}
        onRefuseOfferAccess={onRefuseOfferAccess}
        onFlowCreate={handleFlowCreate}
        toggleControlsModal={offerControlsModalToggle}
        openControlsModal={offerControlsModalOpen}
      />
    </OfferCardInfo>

    <div className="offers-page-content">
      <div className="offers-page-content-left">
        <OfferAdditionalInfo
          offer={offer}
          countries={countries}
          sources={sources}
          handleRequestOfferAccess={onRequestOfferAccess}
          prefix="left"
        />

        {baseCurrency && offer.stats && !offer.modifies.g && (
          <OfferStats statistics={offer.stats} currency={baseCurrency} />
        )}

        {offer.offerStatsYandex && offer.offerStatsYandex.stats && (
          <OfferTargetAudience audience={offer.offerStatsYandex.stats} profile={profile} />
        )}

        {baseCurrency && offer.landings && offer.landings.length > 0 && (
          <OfferLandings
            landings={offer.landings}
            currency={baseCurrency}
            offer={offer}
            site_key={site_key}
            connectOffer={onRequestOfferAccess}
            topItem={topBundle.best_landing}
          />
        )}

        {baseCurrency && offer.transits && offer.transits.length > 0 && (
          <OfferLandings
            name="prelanders"
            landings={offer.transits}
            currency={baseCurrency}
            offer={offer}
            site_key={site_key}
            connectOffer={onRequestOfferAccess}
            topItem={topBundle.best_prelanding}
          />
        )}
      </div>

      <div className="offers-page-content-right">
        <div className="offer-card">
          {offer.description && (
            <OfferCardItem
              id="offer.overview"
              className="offer-overview"
              defaultMessage="Overview"
              html={offer.description}
            />
          )}

          {offer.full_description && (
            <OfferCardItem
              id="offer.description"
              defaultMessage="Description"
              className="offer-description"
              html={offer.full_description}
            />
          )}

          {offer.rules && (
            <OfferCardItem
              id="offer.rules"
              className="offer-rules"
              defaultMessage="Offer's Rules"
              html={offer.rules}
            />
          )}
        </div>

        {offer.id && <OfferNews offerId={offer.id} />}
      </div>

      <DialogModal
        open={confirmModal}
        onConfirm={handleModal}
        onCancel={toggleModal}
        message={<FormattedMessage id="offer.modal.remove" defaultMessage="Remove offer" />}
      />

      {renderAlertModal()}

      <OfferHasFlowsModal
        toggle={offerHasFlowsModalToggle}
        open={offerHasFlowsModalOpen}
        flows={offer.flows}
        onFlowCopy={copyFlow}
        offerId={offer.id}
        isСopied={isСopied}
      />
    </div>
  </div>
);

export default View;
